import React, { useState, useEffect } from 'react';
import apiService from '../services/ApiService';

const DashboardOverview = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const result = await apiService.get('/admin/dashboard/stats');
            setStats(result.data);
        } catch (err) {
            console.error('Failed to fetch stats:', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading || !stats) return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '100px' }}>
            <i className="fas fa-circle-notch fa-spin" style={{ fontSize: '30px', color: 'var(--primary)' }}></i>
        </div>
    );

    return (
        <div className="dashboard-overview">
            <div className="header-section" style={{ marginBottom: '32px' }}>
                <h2 style={{ fontFamily: 'Outfit', fontSize: '24px', fontWeight: '800', margin: '0', color: 'var(--text-main)' }}>
                    Intelligence Hub
                </h2>
                <p style={{ color: 'var(--text-muted)', fontSize: '14px', marginTop: '4px' }}>
                    Live platform telemetry and ecosystem performance metrics.
                </p>
            </div>

            {/* Stats Grid */}
            <div className="grid-responsive" style={{ marginBottom: '32px' }}>
                <div className="col-3 col-lg-6 col-md-12">
                    <StatCard title="Total Registry" value={stats.overview.totalVehicles} icon="car" color="#0ea5e9" trend="+12.5%" />
                </div>
                <div className="col-3 col-lg-6 col-md-12">
                    <StatCard title="Global Users" value={stats.overview.totalUsers} icon="users" color="#8b5cf6" trend="+8.2%" />
                </div>
                <div className="col-3 col-lg-6 col-md-12">
                    <StatCard title="Revenue Stream" value={`₹${stats.overview.totalRevenue?.toLocaleString() || '0'}`} icon="wallet" color="#10b981" trend="+15.1%" />
                </div>
                <div className="col-3 col-lg-6 col-md-12">
                    <StatCard title="Pending Audits" value={stats.overview.pendingPartners} icon="clock" color="#f59e0b" trend="-2.4%" />
                </div>
            </div>

            <div className="grid-responsive" style={{ gap: '32px' }}>
                {/* Main Content: Recent Activity */}
                <div className="col-12">
                    <div className="admin-card" style={{ padding: '0', overflow: 'hidden' }}>
                        <div style={{ padding: '24px 32px', borderBottom: '1px solid var(--border-light)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: 'var(--text-main)' }}>Global Activity Log</h3>
                            <span style={{ fontSize: '11px', fontWeight: '800', color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '1px' }}>Live Feed</span>
                        </div>
                        <div style={{ padding: '16px 0' }}>
                            {stats.recentActivity?.length > 0 ? stats.recentActivity.map((activity, i) => {
                                const isService = activity.type === 'ServiceRequest';
                                const itemDate = new Date(activity.date).toLocaleDateString('en-GB');
                                const isLast = i === stats.recentActivity.length - 1;

                                if (isService) {
                                    const req = activity.data;
                                    return (
                                        <div key={i} style={{ padding: '20px 32px', display: 'flex', alignItems: 'center', gap: '20px', borderBottom: isLast ? 'none' : '1px solid var(--border-light)' }}>
                                            <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: 'var(--bg-main)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--primary)', fontSize: '18px' }}>
                                                <i className={`fas fa-${getServiceIcon(req.service_type)}`}></i>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: '800', fontSize: '14px', color: 'var(--text-main)' }}>{req.service_type.replace(/([A-Z])/g, ' $1').trim()}</div>
                                                <div style={{ fontSize: '12px', color: 'var(--text-dim)', marginTop: '2px' }}>ID: {req.request_id} • {itemDate}</div>
                                            </div>
                                            <div style={{ textAlign: 'right' }}>
                                                <span className={`status-badge status-${req.status}`} style={{ fontSize: '10px' }}>{req.status.toUpperCase()}</span>
                                            </div>
                                        </div>
                                    );
                                } else if (activity.type === 'ChallanPayment') {
                                    const challan = activity.data;
                                    const userName = challan.vehicle_id?.user_id?.name || 'Guest User';
                                    return (
                                        <div key={i} style={{ padding: '20px 32px', display: 'flex', alignItems: 'center', gap: '20px', borderBottom: isLast ? 'none' : '1px solid var(--border-light)' }}>
                                            <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: '#ecfdf5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981', fontSize: '18px' }}>
                                                <i className="fas fa-rupee-sign"></i>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: '800', fontSize: '14px', color: 'var(--text-main)' }}>Challan Payment: ₹{challan.amount}</div>
                                                <div style={{ fontSize: '12px', color: 'var(--text-dim)', marginTop: '2px' }}>Vehicle: {challan.vehicle_number} • By: {userName} • {itemDate}</div>
                                            </div>
                                            <div style={{ textAlign: 'right' }}>
                                                <span className="status-badge" style={{ fontSize: '10px', background: '#ecfdf5', color: '#10b981', border: '1px solid rgba(16, 185, 129, 0.2)' }}>PAID</span>
                                            </div>
                                        </div>
                                    );
                                } else if (activity.type === 'RCSearch') {
                                    const search = activity.data;
                                    const userName = search.searched_by?.name || 'Guest User';
                                    return (
                                        <div key={i} style={{ padding: '20px 32px', display: 'flex', alignItems: 'center', gap: '20px', borderBottom: isLast ? 'none' : '1px solid var(--border-light)' }}>
                                            <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: 'rgba(90, 24, 154, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--primary)', fontSize: '18px' }}>
                                                <i className="fas fa-search"></i>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: '800', fontSize: '14px', color: 'var(--text-main)' }}>RC Search</div>
                                                <div style={{ fontSize: '12px', color: 'var(--text-dim)', marginTop: '2px' }}>Vehicle: {search.vehicle_number} • By: {userName} • {itemDate}</div>
                                            </div>
                                            <div style={{ textAlign: 'right' }}>
                                                <span className="status-badge" style={{ fontSize: '10px', background: search.found ? '#ecfdf5' : '#fef2f2', color: search.found ? '#10b981' : '#ef4444', border: `1px solid ${search.found ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'}` }}>
                                                    {search.found ? 'FOUND' : 'NOT FOUND'}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                }
                                return null;
                            }) : (
                                <div style={{ padding: '60px', textAlign: 'center', color: 'var(--text-dim)' }}>
                                    <i className="fas fa-inbox" style={{ fontSize: '32px', marginBottom: '16px', opacity: 0.5 }}></i>
                                    <p style={{ fontWeight: '700' }}>No recent activity found</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const getServiceIcon = (type) => {
    const icons = {
        'Insurance': 'shield-alt',
        'PayChallan': 'receipt',
        'FitnessPermit': 'check-circle',
        'TransferOwnership': 'exchange-alt',
        'Loan': 'money-bill-wave'
    };
    return icons[type] || 'file-alt';
};

const StatCard = ({ title, value, icon, color, trend }) => (
    <div className="admin-card" style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{
                width: '48px',
                height: '48px',
                background: `${color}10`,
                borderRadius: '14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: color,
                fontSize: '20px',
                border: `1px solid ${color}20`
            }}>
                <i className={`fas fa-${icon}`}></i>
            </div>
            {trend && (
                <div style={{
                    fontSize: '11px',
                    color: trend.startsWith('+') ? 'var(--success)' : 'var(--text-dim)',
                    fontWeight: '800',
                    background: trend.startsWith('+') ? '#ecfdf5' : '#f8fafc',
                    padding: '4px 10px',
                    borderRadius: '8px',
                    border: trend.startsWith('+') ? '1px solid rgba(16, 185, 129, 0.2)' : '1px solid var(--border-light)'
                }}>
                    {trend}
                </div>
            )}
        </div>
        <div>
            <div style={{ color: 'var(--text-muted)', fontSize: '10px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>
                {title}
            </div>
            <div style={{ fontSize: '28px', fontWeight: '800', color: 'var(--text-main)', letterSpacing: '-1px' }}>
                {value}
            </div>
        </div>
    </div>
);

export default DashboardOverview;
